import { navigationGuard } from '@/router/navigationGuard'
import { useStoreApp } from '@/stores/app'
import { routes, handleHotUpdate } from 'vue-router/auto-routes'
import { createRouter, createWebHistory } from 'vue-router'

export const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(navigationGuard)

// Remember where the user came from when entering the admin area so the
// breadcrumb can keep that trail (see BreadcrumbNavigationMenu). Forgotten
// again as soon as they leave it.
router.afterEach((to, from) => {
  const storeApp = useStoreApp()
  const toAdmin = to.path.startsWith('/admin')
  const fromAdmin = from.path.startsWith('/admin')

  if (!toAdmin) {
    storeApp.setAdminReturnRoute(null)
  } else if (!fromAdmin && typeof from.name === 'string') {
    storeApp.setAdminReturnRoute({
      name: from.name,
      params: { ...(from.params as Record<string, string | string[] | undefined>) },
      fullPath: from.fullPath
    })
  }
})

// This will update routes at runtime without reloading the page
if (import.meta.hot) {
  handleHotUpdate(router)
}
